"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetPaymentModel = useGetPaymentModel;
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var CheckoutStepChanged = _interopRequireWildcard(require("@ori-events/checkout-step-changed"));
var _checkoutPayment = require("@ori/checkout-payment");
var _checkoutUtils = require("@ori/checkout-utils");
var _react = require("react");
var _api = require("../api");
var _models = require("../models");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
function useGetPaymentModel(selectedStep) {
  const [activeProviderId, setActiveProviderId] = (0, _react.useState)(0);
  const [isProviderAvailable, setIsProviderAvailable] = (0, _react.useState)(false);
  const [cardConsentIsFulfilled, setCardConsentIsFulfilled] = (0, _react.useState)(false);
  const [shouldMutatePaymentModel, setShouldMutatePaymentModel] = (0, _react.useState)(false);
  const {
    paymentModel,
    isPaymentModelLoading,
    mutate: mutatePaymentModel
  } = (0, _api.useGetPaymentModelQuery)(setActiveProviderId);
  const refreshPayment = event => {
    if (event.detail.pageId === CheckoutStepChanged.CheckoutStep.Payment) {
      void mutatePaymentModel();
    }
  };
  (0, _checkoutUtils.useWindowEvent)(CheckoutStepChanged.Name, refreshPayment);
  (0, _checkoutUtils.useWindowEvent)(BasketUpdated.Name, () => {
    if (selectedStep === _models.ShoppingStep.Checkout) {
      void mutatePaymentModel();
    } else {
      setShouldMutatePaymentModel(true);
    }
  });
  (0, _checkoutUtils.useWindowEvent)(_checkoutPayment.CARD_CONSENT_UPDATED_EVENT, () => {
    void mutatePaymentModel();
  });
  (0, _react.useEffect)(() => {
    if (!paymentModel) {
      return;
    }
    const {
      isCardDetailsConsent,
      selectedPaymentProviderId,
      paymentProviderGroups
    } = paymentModel;
    const provider = paymentProviderGroups.flatMap(group => group.paymentProviders).find(item => item.id === selectedPaymentProviderId);
    setIsProviderAvailable(!!provider);
    if (provider?.isRecurring && !isCardDetailsConsent && !provider.cardDetails) {
      setCardConsentIsFulfilled(false);
    } else {
      setCardConsentIsFulfilled(true);
    }
  }, [paymentModel]);
  return {
    cardConsentIsFulfilled,
    paymentModel,
    isPaymentModelLoading,
    isProviderAvailable,
    activeProviderId,
    shouldMutatePaymentModel,
    setActiveProviderId,
    setShouldMutatePaymentModel,
    mutatePaymentModel
  };
}